import { Injectable } from '@angular/core';
import { UiState } from '../store/ui/ui.reducer';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
  readUiState(): Partial<UiState> {
    try {
      return {
        theme: (localStorage.getItem('theme') as UiState['theme']) || 'light',
        telaVisibility: (localStorage.getItem('telaVisibility') as UiState['telaVisibility']) || 'none',
        darkVariant: (localStorage.getItem('darkVariant') as UiState['darkVariant']) || '1',
        searchEnabled: localStorage.getItem('searchEnabled') === 'true',
        showEaProducts: localStorage.getItem('showEaProducts') === 'true',
      };
    } catch {
      return {};
    }
  }

  writeUiState(state: UiState): void {
    try {
      localStorage.setItem('theme', state.theme);
      localStorage.setItem('telaVisibility', state.telaVisibility);
      localStorage.setItem('darkVariant', state.darkVariant);
      localStorage.setItem('searchEnabled', String(state.searchEnabled));
      localStorage.setItem('showEaProducts', String(state.showEaProducts));
    } catch {
      // Ignore storage errors (private browsing, quota exceeded, etc.)
    }
  }
}
